<div class="wrapper">
  <h1>{{ 'INFOPOINT.SELFCHECK_TITLE' | translate }}</h1><br>
  <div style="max-width: 700px">
    <app-qr-code [uuid]="company.uuid"></app-qr-code>
  </div>
</div>
